import styled from 'styled-components';
import { largeLayout } from '@styles/layout';

export const Card = styled.div`
  display: block;
  padding: 24px;
  box-sizing: border-box;
  width: ${largeLayout.getSize(4)}px;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background: white;
`;


// WEBPACK FOOTER //
// src/app/src/components/Card/Card.s.ts